import EditUserFromAdmin from './component'

export default EditUserFromAdmin
